import { AxiosError, AxiosResponse } from 'axios';
import { useMutation, useQueryClient, UseMutationResult } from 'react-query';
import { ErrorMessage } from 'types';
import { client } from 'utils/api-client';

export default function useUnlockPaymentMethod(): UseMutationResult<
  AxiosResponse,
  AxiosError<ErrorMessage>,
  string
> {
  const queryClient = useQueryClient();

  const unlinkAthlete = (paymentMethodId: string): Promise<AxiosResponse<null>> => {
    return client.put(`payment-methods/${paymentMethodId}/unlock/`);
  };

  return useMutation(unlinkAthlete, {
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ['paymentMethods'],
      });
    },
  });
}
